import React from "react";
import { connect } from "react-redux";

import { faCog } from "@fortawesome/pro-solid-svg-icons/faCog";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Dropdown from "antd/es/dropdown";
import Menu from "antd/es/menu";
import cn from "classnames";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";

import { Role } from "@mapmycustomers/shared";
import User from "@mapmycustomers/shared/types/User";

import Path from "@app/enum/Path";
import SettingPath from "@app/enum/settings/SettingPath";
import { getRole } from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";

import styles from "./SettingsMenu.module.scss";

interface Props {
  className?: string;
  currentUserRole?: User["role"];
}

const SettingsMenu: React.FC<Props> = ({ className, currentUserRole }) => {
  const intl = useIntl();

  return (
    <Dropdown
      overlay={
        <Menu>
          <Menu.Item
            disabled={
              currentUserRole &&
              (currentUserRole.key === Role.MEMBER || currentUserRole.key === Role.READ_ONLY)
            }
          >
            <Link to={`${Path.SETTINGS}/${SettingPath.ORGANIZATION_ACTIVITY_TYPES}`}>
              {intl.formatMessage({
                id: "activityList.settings.activityTypes",
                defaultMessage: "Manage activity types",
                description: "Link name to activity types settings",
              })}
            </Link>
          </Menu.Item>
          <Menu.Item disabled={currentUserRole && currentUserRole.key === Role.READ_ONLY}>
            <Link to={`${Path.SETTINGS}/${SettingPath.PERSONAL_CALENDAR_SYNC}`}>
              {intl.formatMessage({
                id: "activityList.settings.calendarSync",
                defaultMessage: "Calendar sync",
                description: "Link name to calendar sync settings",
              })}
            </Link>
          </Menu.Item>
        </Menu>
      }
      trigger={["click"]}
    >
      <div className={cn(className, styles.iconContainer)}>
        <FontAwesomeIcon icon={faCog} />
      </div>
    </Dropdown>
  );
};

const mapStateToProps = (state: RootState) => ({
  currentUserRole: getRole(state),
});

export default connect(mapStateToProps)(SettingsMenu);
